module.exports = __webpack_public_path__ + "static/courier_new-1c48c97d6892ab12746679247899e543.png";